import Illustration from './illustration';
import List from './list';
import Simple from './simple';
const TextGroup = {
  Illustration,
  List,
  Simple
};
export default TextGroup;
//# sourceMappingURL=index.js.map